import { render, staticRenderFns } from "./Imcufidet.vue?vue&type=template&id=f046aa5e&"
import script from "./Imcufidet.vue?vue&type=script&lang=js&"
export * from "./Imcufidet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports